import { API_URL_WHALESHARK_HIGHLIGHTS } from "@constants/Clients/whaleshark/whaleshark.env";
import apiInstance from "@services/Shared/instanceAxios";
import TCreateEditHighlight from "types/Clients/WhaleShark/hotv/createEditHighlight";

const updateItem = (uuid: string, editedItem: TCreateEditHighlight) =>
  apiInstance({
    url: API_URL_WHALESHARK_HIGHLIGHTS + uuid,
    method: "put",
    data: editedItem,
  });

export default updateItem;
